import { useContext } from 'react';
import type { SlideSet } from '../../../api/slide-set';
import SlideSetsContext from '../toc/_contexts/SlideSetsContext';

const DEFAULT_VALUE = {
  slideSets: [] as SlideSet[],
  setSlideSets: () => {},
  fetchSlideSets: () => {},
  isLoading: false,
};

export default function useSlideSets({ optional }: { optional?: boolean } = {}) {
  const context = useContext(SlideSetsContext);

  if (!context) {
    if (optional) return DEFAULT_VALUE;
    throw new Error('useSlideSets must be used within a SlideSetsContextProvider');
  }

  return context;
}
